module.exports = __webpack_public_path__ + "static/media/javascript-logo.4162cea6.svg";